import api from '@/api';

export const actions = {

    adminRequestsShow({dispatch, commit}, data) {
        return new Promise((resolve, reject) => {
            dispatch('commonStartLoading');
            api({ url: 'requests/' + data.id, method: 'GET' })
                .then(resp => {
                    commit('adminRequestsSetCurrent', resp.data);
                    dispatch('commonEndLoading');
                    resolve(resp.data);
                })
                .catch(err => {
                    dispatch('commonEndLoading');
                    reject(err)
                })
        })
    },

    adminRequestsChangeStatus({dispatch, commit}, data) {
        return new Promise((resolve, reject) => {
            dispatch('commonStartLoading');
            api({ url: 'requests/' + data.id + '/change-status', method: 'PUT', data:data })
                .then(resp => {
                    commit('adminRequestsSetCurrent', resp.data);
                    dispatch('commonEndLoading');
                    resolve(resp.data);
                })
                .catch(err => {
                    dispatch('commonEndLoading');
                    reject(err)
                })
        })
    },

    adminRequestsRemoveTickets({dispatch, commit}, data) {
        return new Promise((resolve, reject) => {
            dispatch('commonStartLoading');
            api({ url: 'requests/' + data.id + '/remove-tickets', method: 'POST' })
                .then(resp => {
                    commit('adminRequestsSetCurrent', resp.data);
                    dispatch('commonEndLoading');
                    resolve(resp.data);
                })
                .catch(err => {
                    dispatch('commonEndLoading');
                    reject(err)
                })
        })
    },

    adminRequestsgetPresignedUrl({dispatch}, data) {
        return new Promise((resolve, reject) => {
            dispatch('commonStartLoading');
            api({ url: 'requests/' + data.request.id + '/get-presigned-url', method: 'POST', data:data.file })
                .then(resp => {
                    dispatch('commonEndLoading');
                    resolve(resp.data);
                })
                .catch(err => {
                    dispatch('commonEndLoading');
                    reject(err)
                })
        })
    },

    adminRequestsStoreTickets({dispatch, commit}, data) {
        return new Promise((resolve, reject) => {
            dispatch('commonStartLoading');
            api({ url: 'requests/' + data.request.id + '/store-tickets', method: 'POST', data:data.file })
                .then(resp => {
                    commit('adminRequestsSetCurrent', resp.data);
                    dispatch('commonEndLoading');
                    resolve(resp.data);
                })
                .catch(err => {
                    dispatch('commonEndLoading');
                    reject(err)
                })
        })
    },
};

